import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 34 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.575 21.548a4.973 4.973 0 1 0 0-9.945 4.973 4.973 0 0 0 0 9.945Z",
      fill: "#CDD3E2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M29.836 3.315H24.58l-2.055-2.238A3.298 3.298 0 0 0 20.089 0h-7.028c-.928 0-1.823.398-2.453 1.077L8.57 3.315H3.315A3.325 3.325 0 0 0 0 6.63v19.89a3.325 3.325 0 0 0 3.315 3.316h26.52a3.325 3.325 0 0 0 3.316-3.316V6.63a3.325 3.325 0 0 0-3.315-3.315Zm-13.26 21.548a8.29 8.29 0 0 1-8.288-8.288 8.29 8.29 0 0 1 8.287-8.287 8.29 8.29 0 0 1 8.288 8.287 8.29 8.29 0 0 1-8.288 8.288Z",
      fill: "#CDD3E2"
    }, null, -1)
  ]))]))
}
export default { render: render }